import { DIGITUM } from "@/tabs/Operation/utils";

export const convertDigitumData = ({ digit }: { digit: string }) => {
    const item = DIGITUM.find((item) => item.value === digit);

    return item
        ? {
              value: digit,
              label: item.label,
          }
        : null;
};
